module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-11.74a0b558.png";